export const MINNESOTA_LMI_FUNNEL_ID = 'mnLmi';
export const MINNESOTA_LMI_FUNNEL_PATH = '/mn-lmi';

export const config = {
  id: MINNESOTA_LMI_FUNNEL_ID,
  path: MINNESOTA_LMI_FUNNEL_PATH,
  show: () => true,
};
